import React from 'react';
import CheckboxGroupInput from '../Inputs/CheckboxGroupInput';
import styles from './OptionsFilter.module.scss';
import ChoiceInput, { Size } from '../Inputs/ChoiceInput';
import classnames from 'classnames';
import { IdName } from 'interfaces/IdName';
import { SearchOptionsType } from 'interfaces/ISearchOptionsType';

type Props = {
  isDisabled?: boolean;
  isMultipleSelect?: boolean;
  isLabelExtended?: boolean;
  label?: string;
  options: SearchOptionsType[];
  allOptions?: SearchOptionsType[];
  onChangeSingle?: (newValue?: IdName) => void;
  onChangeMultiple?: (
    newValue: IdName[],
    allOptions: SearchOptionsType[],
  ) => void;
  selectedItem?: SearchOptionsType;
  selectedItems?: SearchOptionsType[];
  hasHeaderLabel?: boolean;
  isChoicesPadded?: boolean;
  isThreeLineLabel?: boolean;
  choiceInputSize?: Size;
  itemWrapperClassName?: string;
  containerWrapperClassName?: string;
  haveItemsBackground?: boolean;
  wrapperClassName?: string;
  labelFieldName?: string;
  labelEndAdornment?: React.ReactNode;
  noGroupSpaces?: boolean;
};

const OptionsFilter: React.FC<Props> = (props: Props) => {
  const {
    label,
    options,
    allOptions,
    isMultipleSelect,
    hasHeaderLabel,
    haveItemsBackground,
    itemWrapperClassName,
    wrapperClassName,
    isLabelExtended,
    labelFieldName,
    labelEndAdornment,
    noGroupSpaces,
  } = props;

  if (!options || !options.length) {
    return null;
  }

  const renderOptions = () => {
    if (isMultipleSelect) {
      return (
        <CheckboxGroupInput
          data={options}
          onChange={(selectedItems: IdName[]) => {
            props.onChangeMultiple &&
              props.onChangeMultiple(selectedItems, allOptions || options);
          }}
          isDisabled={props.isDisabled}
          selectedItems={props.selectedItems || []}
          size={'regular'}
          itemWrapperClassName={itemWrapperClassName}
          haveItemsBackground={haveItemsBackground}
          hideSelectAndDeselect={true}
          noGroupSpaces={noGroupSpaces}
          labelFieldName={labelFieldName}
        />
      );
    }

    return (
      <ChoiceInput
        labelFieldName={labelFieldName}
        data={options}
        onChange={props.onChangeSingle}
        selectedItem={props.selectedItem}
        isDisabled={props.isDisabled}
        size={props.choiceInputSize || 'regular'}
        itemWrapperClassName={props.itemWrapperClassName}
        isPadded={props.isChoicesPadded}
        isThreeLineLabel={props.isThreeLineLabel}
      />
    );
  };

  return (
    <div
      className={classnames(
        hasHeaderLabel ? styles['header-label-container'] : styles.container,
        wrapperClassName,
      )}
    >
      {label && (
        <div
          className={classnames(styles.label, {
            [styles['header-label']]: hasHeaderLabel,
            [styles['extended']]: isLabelExtended,
          })}
        >
          {label}
          {labelEndAdornment}
        </div>
      )}
      {renderOptions()}
    </div>
  );
};

export default OptionsFilter;
